import React, {useEffect, useRef} from 'react';
import '../../styles/components/dashboard/dashboard-page.scss';
import dashboardPage, {displayInfoModal} from '../../services/dashboard/dashboardPage';
import InfoModal from '../common/InfoModal';
import TabbedNavigation from '../tabbedNavigation/TabbedNavigation';
import {FontIcon} from '../common/FontIcon';
import DashboardContent from './DashboardContent';
import {useAppSelector} from "../../redux/hooks";
import LoadingAnimation2 from "../loadingAnimation/LoadingAnimation2";
import {dashboardStore} from "../../modules/dashboard/store/dashboardPageStore";


export default function DashboardPage() {
  const scrollableContentRef = useRef<HTMLElement>(document.createElement('main'));
  const isDashboardReady = useAppSelector(dashboardStore.getIsReady);

  useEffect(() => {
    // load view model
    void dashboardPage.loadDashboardViewModel();

    return () => {
      // when closed, reset view model
      void dashboardPage.resetDashboardViewModel();
    }
  }, []);
  
  return (
    <div className={`dashboard-page`}>
      <DashboardInfoModal />
      <header className="header">
        <h1>Dashboard</h1>
        <button className={"info-icon"} onClick={()=> displayInfoModal(true) } aria-label={`Show Dashboard information`}>
          <FontIcon icon={"icon-info"}/>
        </button>
      </header>
      <main ref={scrollableContentRef} className={`scrollable-content`}>
        {isDashboardReady ? <DashboardContent />: <LoadingAnimation2/>}
      </main>
      <footer className="footer">
        <TabbedNavigation/>
      </footer>
    </div>
  );
}

const DashboardInfoModal = () => {
  const isVisible = useAppSelector((state) => !!state.dashboardPage.isInfoModalVisible);
  if(!isVisible){ return null; }
  return <InfoModal onClose={()=> displayInfoModal(false)} title={"About Dashboard"} icon={"icon-dashboard"} text={<div>
        Welcome to the Dashboard&thinsp;&mdash;&thinsp;a great place to track your progress and accomplishments.
  </div>}/>
}
